import { ProcessService } from './../../../../services/process.service';
import { Process } from './../../../../models/process-models';
import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-repeatable-process',
    templateUrl: './repeatable-process.component.html',
    styleUrls: ['./repeatable-process.component.scss']
})
export class RepeatableProcessComponent implements OnInit {
    @Input() process: Process;

    subscription: Subscription;
    isToggle: boolean = true;
    processes = [
        { id: 1 },
        { id: 2 },
        { id: 3 }
    ];

    constructor(private processService: ProcessService) {
        this.subscription = this.processService.saveProcessClicked$
        .subscribe(() => this.saveProcess());
    }

    ngOnInit() {
    }

    delete(process: any) {
        const index = this.processes.indexOf(process);
        if (index > -1) {
            this.processes.splice(index, 1);
        }
    }

    push(process: any) {
        this.processes.push(process);
    }

    saveProcess() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
}